<template>
    <v-responsive max-width="1024px" width="100%" height="100%" class="mx-auto overflow-visible">
        <div class="headline text-start mt-8">
            <span v-if="data._id">유통데이터 활용 주요자료 수정</span>
            <span v-else>유통데이터 활용 주요자료 등록</span>
        </div>

        <section class="mt-4">

            <v-card>
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">상이름</v-col>
                        <v-col cols="10">
                            <v-text-field v-model="data.awardName" placeholder="ex) 대상" dense outlined hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">제목</v-col>
                        <v-col cols="10">
                            <v-text-field v-model="data.subject" dense outlined hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">팀명</v-col>
                        <v-col cols="10">
                            <v-text-field v-model="data.name" dense outlined hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">작성일</v-col>
                        <v-col cols="10">
                            <v-text-field :value="$dayjs(data.createdAt).format('YYYY-MM-DD HH:mm:ss')" type="datetime-local" dense outlined hide-details @change="value => data.createdAt = $dayjs(value).toDate()" />
                            <div class="text-caption primary--text">* 작성일이 최신일수록 상단에 노출됩니다</div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">카테고리</v-col>
                        <v-col cols="10">
                            <v-select v-model="data.category" :items="categories" dense outlined hide-details />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider />
                <v-card-text class="py-0">
                    <v-row align="center">
                        <v-col cols="2">분석자료 링크</v-col>
                        <v-col cols="10">
                            <v-text-field v-model="data.link" dense outlined hide-details placeholder="https://" />
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </section>

        <section class="mt-4">
            <v-layout>
                <span class="subtitle-2 font-weight-bold">상세내용</span>
            </v-layout>
            <v-card>
                <v-card-text>
                    <naver-smarteditor v-model="data.content" />
                </v-card-text>
            </v-card>
        </section>

        <section class="mt-4">
            <v-layout>
                <span class="subtitle-2 font-weight-bold">분석자료 내용</span>
            </v-layout>
            <v-card>
                <v-card-text>
                    <naver-smarteditor v-model="data.content2" />
                </v-card-text>
            </v-card>
        </section>

        <v-row justify="center" class="mx-1 my-4">
            <v-col md="auto" sm="auto">
                <v-btn dark color="blue darken-1" @click="save()">저장</v-btn>
            </v-col>
        </v-row>
    </v-responsive>
</template>

<script>
import api from "@/api";
import NaverSmarteditor from '@/components/plugins/naver/naver-smarteditor.vue';
import download from "downloadjs";

export default {
    components: {
        NaverSmarteditor
    },
    data() {
        return {
            data: {
                _id: this.$route.params._id || null,

                name: null,
                awardName: null,

                subject: null,
                category: "2023",
                link: null,
                
                content: null,

                content2: null,

                createdAt: undefined,
            },

            files: null,

            categories: null,
            hashTags: null
        };
    },
    async mounted() {
        await this.init();
    },
    methods: {
        download: (url, name) => api.resource.get(url).then(file => download(file, name)),
        async init() {
            var { setting } = await api.console.setting.get();
            this.hashTags = setting.datas.hashTags;
            this.categories = setting.datas.categories;

            if (this.data._id) {
                let { data } = await api.console.circulation.datas.get({ _id: this.data._id });

                this.data = data;
            }
        },

        async upload(files){
            if(!Array.isArray(files)) return await api.resource.post(files, "/res/circulation/data");

            let _ = [];
            for(let file of files){
                _.push(await api.resource.post(file, "/res/circulation/data"));
            }

            return _;
        },

        validate(){
            try{
                if(!this.data.awardName) throw new Error("상이름을 작성해주세요");
                if(!this.data.name) throw new Error("팀명을 작성해주세요");
                if(!this.data.subject) throw new Error("회사설명을 작성해주세요");
                if(!this.data.category) throw new Error("카테고리를 선택해주세요");
                if(!this.data.content) throw new Error("상세내용을 작성해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        async save() {
            if (this.validate()) {
                this.data._id ? await api.console.circulation.datas.put(this.data) : await api.console.circulation.datas.post(this.data)

                alert("저장되었습니다");
                this.$router.push(`/console/circulation/datas`);
            }
        },
    },
    // computed: {
    //     categories() {
    //         let year = Number(this.$dayjs().format("YYYY"));
    //         let arr = [];
    //         for(let i = 2021; i <= year; i++) {
    //             arr.push(String(i));
    //         }
    //         return arr;
    //     }
    // }
};
</script>
